import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCustomerBackOrders,
  fetchCustomerBackOrdersExcel,
} from "../../../services/customerBackOrderService";

export const fetchCustomerBackOrdersThunk = createAsyncThunk(
  "customerBackOrder/fetch",
  async ({ customerId, dateFrom, dateTo }, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerBackOrders(
        customerId,
        dateFrom,
        dateTo
      );
      return response?.d?.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);

export const fetchCustomerBackOrdersExcelThunk = createAsyncThunk(
  "customerBackOrderExcel/fetch",
  async ({ customerId, dateFrom, dateTo }, { rejectWithValue }) => {
    try {
      const response = await fetchCustomerBackOrdersExcel(
        customerId,
        dateFrom,
        dateTo
      );
      return response?.d?.results || [];
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);
